import Dexie from "dexie";
import db from "../Db";

var DeleteThanatomorphose = Dexie.async(function* () {
  yield db.open();
  yield db.THANATOMORPHOSE.clear();
});

export default DeleteThanatomorphose;
